<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px;height: auto !important"
          toggleable="lg" type="dark" variant="primary">
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Consignor Master</b-navbar-brand>

          <b-navbar-nav class="ml-auto">
            <b-nav-form v-if="
                $sessionsStorage.get('designation') == 'Admin' &&
                $sessionsStorage.get('nameUser') == 'Bhavneesh'
              ">
              <b-button variant="outline-primary" @click="addEditCardFunc()" size="sm">Add</b-button>
              <!-- <b-button
                size="sm"
                class="ml-3"
                @click="getReportsAss('All_Consignor_Report')"
                variant="outline-info"
                >Export as Excel</b-button
              > -->
              <b-button :disabled="ExcelBtnName != 'Export as Excel' ? true : false" class="ml-3"
                @click="getReportsAss('All_Consignor_Report', 'Export as Excel')" size="sm" variant="outline-info">{{
                ExcelBtnName }}
                <b-spinner v-if="ExcelBtnName != 'Export as Excel'" small label="Small Spinner"></b-spinner></b-button>
            </b-nav-form>
          </b-navbar-nav>

          <!-- <b-button
              v-if="
                    $sessionsStorage.get('designation') == 'Admin' &&
                    $sessionsStorage.get('nameUser') == 'Bhavneesh'
                  "
              size="sm"
              class="ml-1"
              @click="getReports('All_Consignor_Report')"
              variant="outline-info"
            >Export</b-button>-->
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <!-- Add Update Form Input End-->
            <b-card class="gutr" v-if="addEditCard">
              <b-row class="align-items-end">
                <b-col md="12">
                  <h5>{{ ConsignorMaster.agentName }} Consignor Details</h5>
                </b-col>
                <b-col md="3">
                  <label for="blType">Consignor Type</label>
                  <model-list-select :list="categoryTypeList" v-model="ConsignorMaster.categoryType"
                    option-value="categoryTypeVal" option-text="categoryTypeTxt" isDisabled></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>
                    Consignor Name
                    <span class="error">*</span>
                  </label>
                  <b-form-input :formatter="capitalizeAll" id="consignorName" name="consignorName"
                    v-model="ConsignorMaster.consignorName" placeholder="Consignor Name"></b-form-input>
                  <span class="error" v-if="!ConsignorMaster.consignorName">
                    {{
                    errorList.consignorName
                    }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>Status :</label>
                  <md-switch :id="'approval' + ConsignorMaster.isConsignorActive" name="approval" class="md-primary"
                    :value="ConsignorMaster.isConsignorActive == 1 ? true : false" @change="activateconsignorMaster()">
                    <h6>
                      <b-badge :variant="
                        ConsignorMaster.isConsignorActive == 1 ? 'success' : 'danger'
                        ">{{
                        ConsignorMaster.isConsignorActive == 1 ? "Active" : "In-Active"
                        }}</b-badge>
                    </h6>
                  </md-switch>
                </b-col>
                <b-col md="6">
                  <label>
                    Address
                    <span class="error">*</span>
                  </label>
                  <b-form-textarea :formatter="capitalizeAll" id="address" name="address"
                    v-model="ConsignorMaster.address"></b-form-textarea>
                  <span class="error" v-if="!ConsignorMaster.address">
                    {{
                    errorList.address
                    }}
                  </span>
                </b-col>
                <b-col md="12">
                  <center>
                    <b-button style="margin-bottom: 0.3rem" variant="success" @click="addconsignorMaster" class="mt-2"
                      id="addButtonLoader">
                      {{ ConsignorMaster.consignorId ? "Update" : "Save" }}
                    </b-button>
                  </center>
                  <md-spinner md-indeterminate id="loader" style="display: none"></md-spinner>
                </b-col>
              </b-row>
            </b-card>
            <!-- Add Update Form Input End-->

            <div class="mt-3">
              <!-- Search Form Input Start-->
              <b-row>
                <b-col md="10" class="my-1">
                  <b-form-group>
                    <b-input-group>
                      <b-form-input :formatter="capitalizeAll" @input="debounceSearch" v-model="filter"
                        placeholder="Type to Search Consignor Master and Code" ref="search" />
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filterClear">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <h5>
                    <small v-if="isLoading == false">{{ totalRows }} Entries</small>
                  </h5>
                </b-col>
              </b-row>
              <!-- Search Form Input End-->
              <!-- Main table element -->
              <div class="table-responsive tableMain">
                <b-table show-empty stacked="md" :items="All_Consignor_List_data" :fields="fields"
                  :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered" responsive
                  primary-key="stateId" class="position-relative">
                  <template slot="agntColoader" slot-scope="row0">
                    <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
                  </template>
                  <template slot="categoryType" slot-scope="row1">
                    <span @click="
                        $sessionsStorage.get('designation') == 'Admin' &&
                        $sessionsStorage.get('nameUser') == 'Bhavneesh'
                          ? viewEdit(row1.item)
                          : ''
                      " class="showMoreData">{{ row1.item.categoryType }}</span>
                  </template>
                  <template slot="agentName" slot-scope="row11">
                    <span>{{
                      row11.item.agentName != "" ? row11.item.agentName : "--"
                      }}</span>
                  </template>
                  <template slot="isConsignorActive" slot-scope="row22">
                    <div v-if="adminToggle == 'Admin'" :id="'row' + row22.item.consignorId">
                      <md-switch :id="'approval' + row22.item.consignorId" name="approval" class="md-primary"
                        :value="row22.item.isConsignorActive == 1 ? true : false"
                        @change="activateConsignorUser(row22.item)">
                        <h6>
                          <br />
                          <b-badge style="margin-left: -45px">{{
                            row22.item.isConsignorActive == 1 ? "Active" : "In-Active"
                            }}</b-badge>
                        </h6>
                      </md-switch>
                    </div>
                    <div v-else :id="'row' + row22.item.consignorId">
                      <h6>
                        <b-badge>{{
                          row22.item.isConsignorActive == 1 ? "Active" : "In-Active"
                          }}</b-badge>
                      </h6>
                    </div>
                  </template>

                  <template slot="action" slot-scope="row2">
                    <b-button variant="outline-primary" @click="editconsignorMaster(row2.item)" id="addButtonLoader"
                      size="sm">Update</b-button>
                  </template>
                  <template slot="companyName" slot-scope="row14">
                    <span>
                      Company Name : {{ row14.item.companyName }}
                      <br />
                    </span>
                    <span>
                      Address : {{ row14.item.address }}
                      <br />
                    </span>
                  </template>
                </b-table>
              </div>
              <b-row>
                <b-col md="12" class="my-1">
                  <b-pagination limit="25" :total-rows="totalRows" :per-page="perPage" v-model="currentPage"
                    class="my-0 pull-right" />
                </b-col>
              </b-row>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect, MultiSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import CommonService from "../../services/CommonService.js";
import ClientUserService from "../../services/ClientUserService.js";
import CustomLoader from "../common/customLoader.vue";
export default {
  beforeMount() {
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/consignorMaster");
      if (globalPermissionStatus("Consignor Master") != "Disabled") {
        this.$sessionsStorage.set(
          "PermissionStatus",
          globalPermissionStatus("Consignor Master")
        );
      } else {
        this.$router.push({
          path: "/dashboard",
        });
      }
      this.getAllConsignorMasterList();
    } else {
      this.$router.push({
        path: "/Login/",
      });
    }
  },
  data() {
    return {
      ExcelBtnName: "Export as Excel",
      addEditCard: false,
      isLoading: false,
      fields: [
        {
          key: "consignorId",
          label: "SN",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "consignorName",
          label: "Consignor Name",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "address",
          label: "Address",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "isConsignorActive",
          label: "Status",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "action",
          label: "Actions",
          sortable: true,
          sortDirection: "desc",
        },
      ],
      currentPage: 1,
      perPage: 10,
      adminToggle: this.$sessionsStorage.get("designation"),
      totalRows: "",
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      modalInfo: { title: "", content: "" },
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },

      ConsignorMaster: {
        consignorId: "",
        categoryType: "Consignor",
        consignorName: "",
        address: "",
        isConsignorActive: true,
        TypeofAdd: "Consignor Master Add"
      },
      ConsignorMasterError: [
        "Please Enter Consignor Name",
        "Please Enter Consignor Address"
      ],
      errorList: {
        consignorName: "",
        address: "",
      },

      All_Consignor_List_data: [],
      categoryTypeList: [
        {
          categoryTypeVal: "Consignor",
          categoryTypeTxt: "Consignor",
        },
      ],
      validate: true,
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    MultiSelect,
  },

  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  methods: {
    activateconsignorMaster() {
      if (
        this.consignorMaster.isConsignorActive == 1 ||
        this.consignorMaster.isConsignorActive == true
      ) {
        this.consignorMaster.isConsignorActive = false;
      } else if (
        this.consignorMaster.isConsignorActive == 0 ||
        this.consignorMaster.isConsignorActive == false
      ) {
        this.consignorMaster.isConsignorActive = true;
      }
    },

    validateRefuelStation() {
      let validate_new = true;

      if (this.consignorMaster.categoryType == "") {
        $("#categoryType").focus();
        this.categoryTypeError = "Select Category";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    activateConsignorUser(item, index) {
        this.itemObj = item;
        this.indexNew = index;

        this.itemObj.isConsignorActive = this.itemObj.isConsignorActive == 1 ? 0 : 1;
        let paylod = {
            tableName: "consignormaster",
            tableId: "consignorId",
            tableIsActive: "isConsignorActive",
            value1: this.itemObj.isConsignorActive,
            tableVal: item.consignorId,
            isMailSend:'No',
             manual:'No',
        };

        ClientUserService.getAllActive(JSON.stringify(paylod))
        .then((response) => {
            const { data, status, statusText } = response;
            if (status == 200 && data) {
            }
        })
        .catch((error) => {
            console.log("Catch on Proforma Error: ", error);
        });
    },
    validateConsignorMaster() {
      let validate_new = true;
      Object.keys(this.errorList).map((x, index) => {
          if (
          this.ConsignorMaster[x] == "" ||
          this.ConsignorMaster[x] == undefined ||
          this.ConsignorMaster[x] == null
          ) {
            console.log("this.ConsignorMaster[x]=>", this.ConsignorMaster);
          this.errorList[x] = this.ConsignorMasterError[index];
          validate_new = false;
          }
      });
      if (validate_new != true) {
          this.validate = false;
          return;
      } else {
          this.validate = true;
      }
    },
    addconsignorMaster() {
        this.validateConsignorMaster();
        this.ConsignorMaster.TypeofAdd = "Consignor Master Add";
        if (this.validate == false) return false;
        this.isLoading = true;

        let payload = {
            itemCode: "add_Consignor_Details",
            ConsignorMaster: this.ConsignorMaster
        };
        payload = JSON.stringify(payload);
        if (this.validate != false) {
            CommonService.getAllCommonMaster(payload)
            .then(response => {
                const { data, status, statusText } = response;
                if (data.consignorId != "" && data.consignorId != undefined) {
                if (data.find == 1 || data.find == 2) {
                    this.alert.content = data.MSG;
                } else {
                    this.alert.content = data.MSG;
                }
                this.addEditCardFunc();
                this.getAllConsignorMasterList();
                } else {
                this.alert.content = data.MSG;
                }
                this.isLoading = false;
                this.$refs["addPop"].open();
            })
            .catch(error => {
                console.log("Catch on Proforma Error: ", error);
            });
        }
    },
    getReportsAss(id, btnName) {
      let excelIdGivin = "";
      if (id == "All_Consignor_Report") {
        excelIdGivin = "All_Consignor_Report";
      }
      let payload = {
        excelId: excelIdGivin,
        assignmentNo: "Consignor",
      };
      this.ExcelBtnName = "Downloading Please Wait...";
      this.$store.dispatch(
        "common/setAllPendingReverseTallyExcel",
        JSON.stringify(payload)
      );
      let ExcelName = "";
      if (this.$store.getters["common/getAllPendingReverseTallyExcel"]) {
        this.ExcelBtnName = btnName;
        ExcelName = this.$store.getters["common/getAllPendingReverseTallyExcel"];
      }
    },
    clearErrVal() {
      this.consignorMaster = {
        categoryType: "Consignor",
        consignorName: "",
        address: "",
        isConsignorActive: true,
        TypeofAdd: "Consignor Master Add",
      };
    },
    getAllConsignorMasterList() {
        this.isLoading = true;
        let payload = {
            itemCode: "All_Consignor_List",
            Filter: this.Filter
        };
        // JSON.stringify();
        // await
         CommonService.getAllCommonMaster(payload)
        .then(response => {
            const { data, status, statusText } = response;
            if (status == 200 && data) {
                this.All_Consignor_List_data = data.All_Consignor_List_data;
                this.totalRows = data.All_Consignor_List_data.length;
                console.log("All_Consignor_List response=>", data);
            } else {
                this.All_Consignor_List_data = [];
            }
            this.isLoading = false;
        })
        .catch(error => {
            console.log("Catch on All_Consignor_List Error: ", error);
        });
    },

    editconsignorMaster(item) {
      console.log(item);
      this.clearErrVal();
      this.addEditCard = true;
      item.TypeofAdd = "Consignor Master Update";
      this.ConsignorMaster = item;
      this.setFocus();
    },
    addEditCardFunc() {
      this.clearErrVal();
      this.addEditCard = !this.addEditCard;
    },
    setFocus: function () {
      // Note, you need to add a ref="search" attribute to your input.
      this.$refs.search.focus();
    },
    previousSalesView() {
      window.history.go(-1);
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getAllConsignorMasterList("0", "0", "1", "1");
      }, 1000);
    },
    filterClear() {
      this.filter = "";
      this.getAllConsignorMasterList("0", "0", "1", "1");
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    JqueryFun() {
      return $(function () {
        return $("#portLocationNew").DataTable();
      });
    },
  },
};
</script>

<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// consignorMaster.vue?2b82cce0